import { Col, Container, Row } from "react-bootstrap";
import KeyValueForm from "../../../Components/Forms/KeyValueForm/KeyValueForm";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import { useAddNewKeyValueMutation } from "../../../services/bClientApi";

export default function AddKeyValuePage() {

  const [
    addNewKeyValue,
    {
      isLoading,
      error
    }
  ] = useAddNewKeyValueMutation()

  const dispatch = useAppDispatch()
  const handleSubmit = async (data: any) => {
    const values: any = {
      ...data
    }
    const newKeyValue = await addNewKeyValue(values).unwrap()
    if (newKeyValue._id) {
      dispatch(navigateTo(`/key-value/${newKeyValue._id}`))
    }
    return newKeyValue
  }

  return (
    <Container>
      <Row>
        <Col>
          <h1>Add Key Value</h1>
          <hr />
          {error && (<>{JSON.stringify(error)}<br /></>)}

          <KeyValueForm
            initialValues={{
                namespace: '',
                key: '',
                value: '',
                expiresAt: undefined,
            }}
            disabled={isLoading}
            onSubmit={handleSubmit}
          />
        </Col>
      </Row>
    </Container>
  )
}